import React from 'react';
import './About.css';
import headshot from './heashot.png';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-container">

      {/* ── HERO ── */}
      <section className="about-hero">
        <div className="about-hero-text">
          <span className="about-eyebrow">Based in Ontario · 5+ Years Experience</span>
          <h1>I Build Digital Products That <em>Actually Make Money</em></h1>
          <p>
            I'm Matt Duarte a Computer Science student at Brock University and the founder of
            DuDigital. Over the last 5 years I've shipped 120+ projects for small businesses
            across Ontario and built an app that hit 30,000 organic downloads with zero ad spend.
            I don't just write code, I build things that perform.
          </p>
          <div className="about-ctas">
            <button className="btn-primary" onClick={() => navigate('/contact')}>
              Work With Me
            </button>
            <button className="btn-secondary" onClick={() => navigate('/projects')}>
              See My Work
            </button>
          </div>
        </div>
        <div className="about-hero-image">
          <div className="about-image-wrap">
            <img src={headshot} alt="Matt Duarte" />
          </div>
          <div className="about-image-badge">
            <span className="badge-num">120<span>+</span></span>
            <span className="badge-label">Projects Shipped</span>
          </div>
        </div>
      </section>

      {/* ── CREDIBILITY STATS ── */}
      <div className="about-stats">
        <div className="about-stat">
          <div className="astat-num">120<span>+</span></div>
          <div className="astat-label">Projects Completed</div>
        </div>
        <div className="about-stat">
          <div className="astat-num">30<span>k</span></div>
          <div className="astat-label">Organic App Downloads</div>
        </div>
        <div className="about-stat">
          <div className="astat-num">5<span>yr</span></div>
          <div className="astat-label">In the Industry</div>
        </div>
        <div className="about-stat">
          <div className="astat-num">$0</div>
          <div className="astat-label">Ad Spend for 30k Downloads</div>
        </div>
      </div>

      {/* ── WHY TRUST ME ── */}
      <section className="about-section">
        <div className="section-eyebrow">Why Work With Me</div>
        <div className="section-title">I've Done This Before... A Lot</div>
        <div className="trust-grid">
          <div className="trust-card">
            <div className="trust-icon">🎓</div>
            <h3>Formally Trained</h3>
            <p>Computer Science at Brock University. I understand the fundamentals, not just
            how to copy-paste from AI LLM's. I have cybersecurity expertise and create software that makes money.</p>
          </div>
          <div className="trust-card">
            <div className="trust-icon">📈</div>
            <h3>Results-Driven</h3>
            <p>120+ projects shipped. My biggest app reached 30,000 organic downloads with zero
            paid advertising, because good product beats big budget.</p>
          </div>
          <div className="trust-card">
            <div className="trust-icon">🤝</div>
            <h3>Straight Shooter</h3>
            <p>You'll always know where your project stands. No jargon, no runaround, just
            clear communication and honest timelines.</p>
          </div>
          <div className="trust-card">
            <div className="trust-icon">🏙️</div>
            <h3>Ontario Local</h3>
            <p>Born in Hamilton, building for Ontario businesses. I understand the local market
            and I'm always reachable, no overseas handoffs, ever.</p>
          </div>
        </div>
      </section>

      {/* ── STORY ── */}
      <section className="about-story">
        <div className="story-text">
          <div className="section-eyebrow">My Story</div>
          <div class="section-title">Started in Hamilton, Built for Ontario</div>
          <p>
            I got into software in 2019 because I saw a gap, small businesses around me had
            terrible websites or none at all, while bigger companies were cleaning up online.
            I figured I could fix that.
          </p>
          <p>
            What started as helping out local businesses turned into 120+ completed projects
            spanning web development, app development, and consulting. Along the way I built
            an app from scratch that grew to 30,000 users organically — no marketing budget,
            just a product people actually wanted to use.
          </p>
          <p>
            I'm still studying CS at Brock because I believe in understanding the craft deeply,
            not just shipping fast. Every project gets my full attention,  whether it's a
            5-page site for a local shop or a full-scale app.
          </p>
        </div>
        <div className="story-personal">
          <div className="personal-card">
            <div className="personal-heading">When I'm Not Coding</div>
            <div className="personal-items">
              <div className="personal-item">
                <span className="personal-icon">🏒</span>
                <div>
                  <strong>Hockey player</strong>
                  <span>I've built sites for training centres and understand the sports
                  business world firsthand.</span>
                </div>
              </div>
              <div className="personal-item">
                <span className="personal-icon">🍕</span>
                <div>
                  <strong>Big-time foodie</strong>
                  <span>I know what a restaurant website needs to actually make someone
                  hungry enough to book a table.</span>
                </div>
              </div>
              <div className="personal-item">
                <span className="personal-icon">📍</span>
                <div>
                  <strong>Hamilton born</strong>
                  <span>Ontario-rooted, Ontario-focused. I care about the businesses
                  in my backyard.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <div className="about-cta-block">
        <h2>Ready to Build Something That Performs?</h2>
        <p>Book a free 15-minute call, no pitch, just honest advice.</p>
        <button
          className="btn-primary"
          onClick={() => window.open('https://calendly.com/mattduarte56/15min')}
        >
          Book My Free Call →
        </button>
      </div>

    </div>
  );
};

export default About;
